import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { errMsg } from "@/api";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    setError("");
    try {
      await api.post("/auth/login", { email, password });
      nav("/admin");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-stone-100 p-4">
      <form
        data-testid="admin-login-form"
        onSubmit={submit}
        className="w-full max-w-sm border border-stone-300 bg-white p-8 shadow-sm"
      >
        <p className="font-spacemono text-[10px] font-bold tracking-widest text-stone-500">LATE NIGHTS MEDIA</p>
        <h1 className="mt-1 text-xl font-bold text-stone-900">Admin sign in</h1>

        <label htmlFor="admin-email" className="mt-6 block text-xs font-semibold text-stone-600">Email</label>
        <input
          id="admin-email"
          data-testid="admin-email-input"
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="mt-1 w-full border border-stone-300 px-3 py-2 text-sm focus:border-stone-900 focus:outline-none"
        />

        <label htmlFor="admin-password" className="mt-4 block text-xs font-semibold text-stone-600">Password</label>
        <input
          id="admin-password"
          data-testid="admin-password-input"
          type="password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="mt-1 w-full border border-stone-300 px-3 py-2 text-sm focus:border-stone-900 focus:outline-none"
        />

        {error && (
          <p data-testid="admin-login-error" className="mt-3 border border-red-200 bg-red-50 px-3 py-2 text-xs text-red-700">
            {error}
          </p>
        )}

        <button
          data-testid="admin-login-submit"
          type="submit"
          disabled={busy}
          className="mt-6 w-full bg-stone-900 px-4 py-2.5 text-sm font-semibold text-white hover:bg-stone-700 disabled:opacity-60"
        >
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
